var _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _rect2, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTask3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3285 4.71143H25.3655C25.6527 8.73331 24.3504 12.9467 19.3135 13.5213",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11392 4.71143H2.03786C1.75058 8.73331 3.05291 12.9467 8.08984 13.5213",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 2.72607V10.1122C7 12.0848 9.17939 16.5855 13.5691 16.5855C20.3488 16.5855 20.2148 10.642 20.2148 10.3218C20.2148 10.1526 20.2212 4.73438 20.2148 2.5",
    stroke: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 0.5,
    width: 14.7428,
    height: 2.0643,
    rx: 1.03215,
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.375 20C10.375 19.6548 10.6548 19.375 11 19.375H16C16.3452 19.375 16.625 19.6548 16.625 20V21C16.625 21.3452 16.3452 21.625 16 21.625H11C10.6548 21.625 10.375 21.3452 10.375 21V20Z",
    stroke: "currentColor",
    strokeWidth: 0.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19.5C11.1532 18.9637 11.4367 17.1185 11.3447 16",
    stroke: "currentColor",
    strokeWidth: 0.75
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.5C15.8468 18.9637 15.4159 17.1185 15.5078 16",
    stroke: "currentColor",
    strokeWidth: 0.75
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17285 23.9902C7.17285 22.6095 8.29214 21.4902 9.67285 21.4902H17.692C19.0727 21.4902 20.192 22.6095 20.192 23.9902V26.9998C20.192 27.276 19.9681 27.4998 19.692 27.4998H7.67285C7.39671 27.4998 7.17285 27.276 7.17285 26.9998V23.9902Z",
    stroke: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.35645,
    y: 23.6353,
    width: 8.65253,
    height: 1.71956,
    rx: 0.859781,
    stroke: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7057 5.43128L13.7028 5.4312L13.7057 5.43128ZM13.7057 5.43128C13.7152 5.43157 13.725 5.43454 13.734 5.44048C13.743 5.44645 13.751 5.45537 13.7564 5.46688C13.7564 5.46693 13.7564 5.46697 13.7564 5.46702L14.5802 7.24102L14.6669 7.42771L14.8709 7.45482L16.7786 7.7082C16.7878 7.70979 16.7972 7.71396 16.8054 7.72101L17.049 7.43589L16.8054 7.72101C16.8141 7.72841 16.8213 7.73879 16.8253 7.75143C16.8294 7.7641 16.8299 7.77788 16.8268 7.79096C16.8238 7.80345 16.8177 7.81418 16.8099 7.82232L15.4144 9.17178L15.2702 9.31117L15.3061 9.50846L15.654 11.4214L15.6541 11.4218C15.6566 11.4353 15.6552 11.4492 15.6503 11.4616C15.6455 11.474 15.6376 11.4838 15.6285 11.4905L15.8513 11.7922L15.6285 11.4905C15.6195 11.4972 15.6095 11.5007 15.5997 11.5013C15.5898 11.502 15.5797 11.4998 15.5703 11.4946L15.5698 11.4943L13.8851 10.5652L13.7044 10.4656L13.5235 10.5649L11.8311 11.494L11.83 11.4946C11.8206 11.4998 11.8105 11.502 11.8006 11.5013C11.7908 11.5007 11.7808 11.4972 11.7718 11.4905C11.7627 11.4838 11.7549 11.474 11.75 11.4616C11.7452 11.4493 11.7438 11.4355 11.7462 11.4221C11.7462 11.422 11.7462 11.4219 11.7462 11.4218L12.1008 9.50973L12.1375 9.31182L11.9928 9.17186L10.5953 7.81963L10.5953 7.81963L10.5932 7.81762C10.5846 7.80946 10.5779 7.79831 10.5745 7.78509C10.5711 7.77183 10.5716 7.7578 10.5757 7.74489C10.5798 7.73202 10.5871 7.72147 10.596 7.71401C10.6048 7.7066 10.6148 7.70242 10.6246 7.70114L12.5281 7.45498L12.7323 7.42857L12.8196 7.24209L13.6504 5.46761L13.6504 5.46762M13.7057 5.43128L13.6504 5.46762M13.6504 5.46762L13.6509 5.46657M13.6504 5.46762L13.6509 5.46657M13.6509 5.46657C13.6556 5.45652 13.6623 5.44839 13.6699 5.4425C13.6771 5.43687 13.6851 5.43335 13.693 5.43175L13.6509 5.46657Z",
    stroke: "currentColor",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask3);
export default __webpack_public_path__ + "static/media/task-3.237c76e1b3f88c1c0bcc076f96864dbb.svg";
export { ForwardRef as ReactComponent };